export const lookupInputClaim = (claimId: string, inputClaimMap?: { [baseId: string]: string }) => {
    return inputClaimMap?.[claimId] ? inputClaimMap[claimId] : claimId;
}